/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
  Paper,
  Typography,
  Button,
  Box,
  Fade,
} from '@material-ui/core';

const TourTooltip = ({
  continuous,
  index,
  isLastStep,
  size,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
}) => (
  <Fade in timeout={250}>
    <Paper
      elevation={8}
      {...tooltipProps}
      style={{
        padding: 24,
        borderRadius: 12,
        maxWidth: 430,
      }}
    >
      {step.title && (
        <Typography
          variant="h6"
          gutterBottom
          style={{ fontWeight: 700 }}
        >
          {step.title}
        </Typography>
      )}

      <Typography
        variant="body2"
        style={{
          lineHeight: 1.7,
          marginBottom: 24,
        }}
      >
        {step.content}
      </Typography>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Button
          {...skipProps}
          color="secondary"
          disableElevation
          variant="outlined"
        >
          Skip the tour
        </Button>

        <Box display="flex">
          {index > 0 && (
            <Button
              {...backProps}
              style={{ marginRight: 8 }}
              disableElevation
              variant="outlined"
              color="primary"
            >
              Back
            </Button>
          )}

          <Button
            {...(continuous ? primaryProps : closeProps)}
            variant="contained"
            color="primary"
            disableElevation
          >
            {isLastStep ? 'Finish' : 'Next'}
          </Button>
        </Box>
      </Box>

      <Typography
        variant="caption"
        color="textSecondary"
        style={{
          display: 'block',
          textAlign: 'center',
          marginTop: 16,
        }}
      >
        {index + 1}
        {' '}
        /
        {size}
      </Typography>
    </Paper>
  </Fade>
);

TourTooltip.propTypes = {
  continuous: PropTypes.bool,
  index: PropTypes.number,
  isLastStep: PropTypes.bool,
  size: PropTypes.number,
  step: PropTypes.object,
  backProps: PropTypes.object,
  closeProps: PropTypes.object,
  primaryProps: PropTypes.object,
  skipProps: PropTypes.object,
  tooltipProps: PropTypes.object,
};

export default TourTooltip;
